const UPI_INTENT_PREFIX = "upi_intent";

export const UPI_INTENT_TEST_IDS = {
    CONTAINER: `${UPI_INTENT_PREFIX}_container`,
    META: `${UPI_INTENT_PREFIX}_meta`,
    CANCEL_PAYMENT_LINK: `${UPI_INTENT_PREFIX}_cancel`,
};
